import type { CheckPendingOrdersResponse } from '../types/pending-orders';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

const ENDPOINT = 'api/app/check-pending-orders';

/**
 * Serviço para verificar pedidos pendentes do usuário
 */
export class CheckPendingOrdersService {
  private readonly httpClient: IHttpClient;

  constructor(httpClient: IHttpClient) {
    this.httpClient = httpClient;
  }

  /**
   * Verifica se o usuário possui pedidos pendentes
   * @returns Promise com a resposta da API contendo informações sobre pedidos pendentes
   */
  async execute(): Promise<CheckPendingOrdersResponse> {
    console.log('[CheckPendingOrdersService] Iniciando chamada à API');
    
    try {
      // Fazer a chamada real à API
      console.log('[CheckPendingOrdersService] Enviando requisição para a API:', ENDPOINT);
      const response = await this.httpClient.sendRequest<CheckPendingOrdersResponse, void>({
        endpoint: ENDPOINT,
        method: HttpMethod.GET
      });
      console.log('[CheckPendingOrdersService] Resposta da API:', response);
      return response;
      
      /* Resposta mock para testes (desativada)
      const mockResponse: CheckPendingOrdersResponse = {
        has_pending_orders: true,
        pending_orders: [
          {
            id: '123',
            merchant_slug: 'loja-teste',
            status: 1 // Pendente
          }
        ]
      };
      console.log('[CheckPendingOrdersService] Retornando resposta mock para testes:', mockResponse);
      return Promise.resolve(mockResponse);
      */
    } catch (error) {
      console.error('[CheckPendingOrdersService] Erro na chamada à API:', error);
      throw error;
    }
  }
}
